import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import NewsTopic from '../../../../components/newsTopic';
import ContentTitle from '../../../../components/contentTitle';
import NewsList from '../../../../components/newsList';
import ListTitle from '../../../../components/listTitle';
import HouseAreaList from './houseAreaList';
import { getNewsDataList } from '../../../../../services/indexApi';

class HomeBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        listOne: PropTypes.string,
        listTwo: PropTypes.string,
        isGZ: PropTypes.bool,
    };

    state = {
        areaTitle: '',
        areaList0: '',
        areaList1: '',
        isTitleShow: true,
        isList0Show: true,
        isList1Show: true,
    };

    async componentDidMount() {
        const { listOne, listTwo, isGZ } = this.props;

        if (isGZ) {
            try {
                const areaTitle = await getNewsDataList('40051');

                this.setState({
                    areaTitle,
                    isTitleShow: !(typeof areaTitle === 'string' && areaTitle !== ''),
                });
            } catch (e) {
                console.error(e);
            }
        }

        if (listOne && listTwo) {
            try {
                const areaList0 = await getNewsDataList(listOne);
                const areaList1 = await getNewsDataList(listTwo);

                this.setState({
                    areaList0,
                    areaList1,
                    isList0Show: !(typeof areaList0 === 'string' && areaList0 !== ''),
                    isList1Show: !(typeof areaList1 === 'string' && areaList1 !== ''),
                });
            } catch (e) {
                console.error(e);
            }
        }
    }

    render() {
        const { areaTitle, areaList0, areaList1, isTitleShow, isList0Show, isList1Show } = this.state;
        const {
            content: { homeTopic, homeTitle0, homeTitle1, homeList0, homeList1, homeList2 },
            listOne,
            listTwo,
        } = this.props;

        return (
            <div id="homeNewsList" className={styles.home_box}>
                <Chip id="50074" type="struct" title="房产家居栏标题" groupName="房产家居栏" content={homeTopic}>
                    <NewsTopic />
                </Chip>
                {typeof areaTitle === 'string' && areaTitle !== '' ? (
                    <Chip
                        id="40051"
                        type="static"
                        title="地方站房产头条1"
                        groupName="房产家居栏"
                        content={areaTitle}
                        position="relative">
                        <HouseAreaList />
                    </Chip>
                ) : (
                    ''
                )}
                {isTitleShow ? (
                    <Chip
                        id="75085"
                        type="recommend"
                        title="房产家居栏头条1"
                        groupName="房产家居栏"
                        content={homeTitle0}
                        translate="handleNewsContentData">
                        <ContentTitle />
                    </Chip>
                ) : (
                    ''
                )}
                {typeof areaList0 === 'string' && areaList0 !== '' ? (
                    <Chip
                        id={listOne}
                        type="static"
                        title="地方站房产新闻列表1"
                        groupName="房产家居栏"
                        content={areaList0}
                        position="relative">
                        <HouseAreaList />
                    </Chip>
                ) : (
                    ''
                )}
                {isList0Show ? (
                    <Chip
                        id="75086"
                        type="recommend"
                        title="房产家居栏新闻列表1"
                        groupName="房产家居栏"
                        content={homeList0}
                        translate="handleNewsContentData">
                        <NewsList isList />
                    </Chip>
                ) : (
                    ''
                )}
                <Chip
                    id="75087"
                    type="recommend"
                    title="房产家居栏头条2"
                    groupName="房产家居栏"
                    content={homeTitle1}
                    translate="handleNewsContentData">
                    <ListTitle />
                </Chip>
                {typeof areaList1 === 'string' && areaList1 !== '' ? (
                    <Chip
                        id={listTwo}
                        type="static"
                        title="地方站房产新闻列表2"
                        groupName="房产家居栏"
                        content={areaList1}
                        position="relative">
                        <HouseAreaList />
                    </Chip>
                ) : (
                    ''
                )}
                {isList1Show ? (
                    <Chip
                        id="75088"
                        type="recommend"
                        title="房产家居栏新闻列表2"
                        groupName="房产家居栏"
                        content={homeList1}
                        translate="handleNewsContentData">
                        <NewsList isList />
                    </Chip>
                ) : (
                    ''
                )}
                <Chip
                    id="75089"
                    type="recommend"
                    title="房产家居栏新闻列表3"
                    groupName="房产家居栏"
                    content={homeList2}
                    translate="handleNewsContentData">
                    <NewsList isList />
                </Chip>
            </div>
        );
    }
}

export default errorBoundary(HomeBox);
